import React from 'react';
import './DeleteConfirmationModal.css';
import { ConfigItem, ProductConfigItem } from '../api/config';
import { FormModal } from './shared/FormModal';

interface DeleteConfirmationModalProps {
  config: ConfigItem | ProductConfigItem;
  onConfirm: () => void;
  onClose: () => void;
  isDeleting: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  config,
  onConfirm,
  onClose,
  isDeleting,
}) => {
  const isProduct = 'productId' in config;

  return (
    <FormModal
      title="Confirm Delete"
      onClose={onClose}
      pending={isDeleting}
      contentClassName="delete-confirmation-modal"
      actions={[
        { label: 'Cancel', variant: 'secondary', onClick: onClose },
        {
          label: isDeleting ? 'Deleting…' : 'Delete',
          variant: 'destructive',
          onClick: onConfirm,
        },
      ]}
    >
      <p className="modal-description">
        You are about to permanently delete this {isProduct ? 'product' : 'global'} configuration.
        This action cannot be undone.
      </p>
      <div className="delete-summary">
        {isProduct && (
          <div className="delete-summary-row">
            <span className="delete-summary-label">Product ID:</span>
            <span className="delete-summary-value">{config.productId}</span>
          </div>
        )}
        <div className="delete-summary-row">
          <span className="delete-summary-label">Key:</span>
          <span className="delete-summary-value">{config.key}</span>
        </div>
        <div className="delete-summary-row">
          <span className="delete-summary-label">Value:</span>
          <span className="delete-summary-value">{config.value}</span>
        </div>
        <div className="delete-warning-box">
          <strong className="delete-warning-title">Warning:</strong>
          <span className="delete-warning-text">
            Deleting this configuration may impact runtime behavior immediately if it is actively read
            by services. Ensure this key is not required by critical paths before proceeding.
          </span>
        </div>
      </div>
    </FormModal>
  );
};

export default DeleteConfirmationModal;
